import React from 'react';
import  { Container, Row, Col, Card, Form, Button,  Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import Multiselect from 'multiselect-react-dropdown';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CreateOrganization, GetOrganizationById, UpdateOrganization, GetOrganization } from '../../utils/axios/CompanyAPI';
import { TimerAlert, ConfirmAlert } from '../../utils/swtAlert';
import { GetGeoLocation } from '../../utils/axios/GeoLocationAPI';
import { GrokLoading } from '../page-layout/loading/Loading';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { Decrypt } from '../../utils/Helper';
import { CreateUser } from '../../utils/axios/UserApi';
import { ROLE, ORGANIZATION_TYPE } from "../constants/constants"

function CompanyDetail(props) {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();

    const [logoURL, setLogoURL] = useState(null);
    const [progresspercent, setProgresspercent] = useState(0);
    const [loading, setLoading] = useState(true);
    //Form Control Variables Starts..
    const [companyName, setCompanyName] = useState("");
    const [business, setBusiness] = useState("");
    const [selectedIndustryTypes, setSelectedIndustryTypes] = useState([]);
    const [companyBrief, setCompanyBrief] = useState("");
    const [websiteURL, setWebsiteURL] = useState("");
    const [address1, setAddress1] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");
    const [pincode, setPincode] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactNumber, setContactNumber] = useState('');
    const [contactDesignation, setContactDesignation] = useState("");
    const [contactEmail, setContacEmail] = useState("");
    const [countryList, setCountryListData] = useState([]);
    const [stateList, setStateListData] = useState([]);
    const [districtList, setDistrictListData] = useState([]);
    const [cityListData, setCityListData] = useState([]);
    const [industryTypeList, setIndustryTypeList] = useState([]);
    const [isEnabled, setIsEnabled] = useState(false);
    const [numberSuccess, setNumberSuccess] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [numberError, setNumberError] = useState("");
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    //Form Control Variables Ends..

    const BackBtn = () => {
        navigate('/industrypartner', { state: { companyid: null } });
    }
    const isValidContactNumber = (e) => /^[6-9][0-9]+$/.test(e);

    const setValuePhoneNumber = (evt) => {
        setContactNumber(evt);

        // if (isValidContactNumber(evt)) {
        //     setNumberSuccess(true);
        //     setNumberError("");
        // } else {
        //     setNumberError("Number should start with 6, 7, 8, or 9");
        //     setNumberSuccess(false);
        // }
    }

    function convertToBase64(e) {
        var file = e.target.files[0];
        if (file) {
            if (file.size <= 5 * 1024 * 1024) { 
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    setLogoURL(reader.result);
                    setErrorMessage('');
                    setShowRemoveButton(false);
                };
                reader.onprogress = (e) => {
                    setProgresspercent(((e.loaded / e.total) * 100).toFixed());
                };
                reader.onerror = error => {
                    console.log("Error:", error);
                };
            } else {
                setErrorMessage("File size exceeds 5MB");
                setShowRemoveButton(true);
            }
        }
    }

    const fileInputRef = useRef(null);

    function handleRemoveLogo() {
        setLogoURL(null);
        setErrorMessage('');
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setShowRemoveButton(false);
    }

    const handleSubmit = (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
            const form = event.currentTarget;

            if (selectedIndustryTypes.length === 0) {
                setValidated(true);
                return;
            }

            if (form && form.checkValidity && form.checkValidity() === false) {
                event.stopPropagation();
                setValidated(true);
                return;
            }

            // if (!isValidContactNumber(contactNumber)) {
            //     setNumberError("Number should start with 6, 7, 8, or 9");
            //     return;
            // }

            if (errorMessage) {
                setErrorMessage("File size exceeds 5MB");
                return;
            }

             else {
                saveOrganization();
            }
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
          event.preventDefault();
        }
    };
    
    const saveOrganization = async () => {
        let OrganisationTypeID = ORGANIZATION_TYPE.COMPANY; // OrganizationType-Company
        let organizationPayload = {
                Business: business,
                OrganizationType: OrganisationTypeID, // OrganizationType-Company
                Name: companyName,
                IndustryType: selectedIndustryTypes.map(item => item.value),
                Brief: companyBrief,
                WebsiteURL: websiteURL,
                Logo:logoURL,
                Address1: address1,
                Country: country,
                City: city,
                District: district,
                Pincode: pincode,
                State: state,
                ContactName: contactName,
                ContactNumber: contactNumber,
                ContactDesignation: contactDesignation,
                ContactEmail: contactEmail,
                IsEnable: isEnabled == false ? "false" : "true",
                IsApproved: true,
        }
        if (location.state.companyid != null) {
            organizationPayload.UpdatedBy = userInfo._id;
            var response = await UpdateOrganization(organizationPayload, location.state.companyid);
            if (response.message) {
                TimerAlert('Industry Partner Creation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'Industry Partner Updated Successfully', 'success');
                setTimeout(() => navigate("/industrypartner"), delay);
            }
        }
        else {
            organizationPayload.CreatedBy = userInfo._id;
            var response = await CreateOrganization(organizationPayload);
            if(response.message) {
                TimerAlert('Industry Partner Creation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                // IF the repsonse is sucessful: Industry partner Added Successfully
                // Fetch the organisation details from the API: Get ALL Organisation
                setLoading(true);
                let organizationPayload = {
                    OrganizationType: OrganisationTypeID
                }
                var orgResponse = await GetOrganization(organizationPayload);
                // Keep a variable to store the organisation Name, find the Object ID with this name.
                let orgID = orgResponse.data.find(item => item.Name === companyName)._id;
                //Using the above information create the new user for the organisation.
                let userPayload = {
                    OrganizationId: orgID,
                    RoleId: ROLE.COMPANY,//Role-Industry Partner
                    Name: contactName,
                    Email: contactEmail,
                    Password: 'password',
                    ContactNumber: contactNumber,
                    PhotoURL: logoURL,
                    CreatedBy: userInfo._id,
                    Enabled: true
                }
                //Call the API to create the user.
                var response = await CreateUser(userPayload);
                setLoading(false);
                if(response.message) {
                    TimerAlert('User Creation Failed', 'Email already used', 'error');
                }
                else {
                  var delay = TimerAlert('success', 'Industry Partner Added with its user Successfully', 'success');
                  setTimeout(() => navigate("/industrypartner"), delay);
                }
            }
        }
    }

    const bindFormPreloadData = async () => {
        setLoading(true);
        //Getting Country List from Geolocations
        var countrylist = await loadGeoLocationData(0, 1);
        setCountryListData(countrylist);
        // var statelist = await loadGeoLocationData(1, 2);
        // // if (statelist.success) {
        //     setStateListData(statelist);
        // }
        // else {
            //Error Handle..
        // }
        let industryTypePayLoad = {
            Type: 3,
        }
        var industryTypeResponse = await GetLookUps(industryTypePayLoad);
        setIndustryTypeList(industryTypeResponse.data);
        setLoading(false);
    };

    const loadGeoLocationData = async (rootId, type) => {
        var result = await GetGeoLocation(rootId, type);
        return result;
    }

    const countryChanged = async (event) => {
        setCountry(event.target.value);
        if(event.target.value !== ''){
            const selectedItemId = event.target.value;
            const selectedItem = countryList.find((item) => item._id === selectedItemId)
            setLoading(true);
            var states = await loadGeoLocationData(selectedItem.Id, 2);
            setStateListData(states);
            setDistrictListData([]);
            setCityListData([]);
            setState("");
            setDistrict("");
            setCity("");
            setLoading(false);
        }
        else {
            setState('');
            setDistrict('');
            setCity('');
            setStateListData([]);
            setDistrictListData([]);
            setCityListData([]);
        }
        // if (states.success) {
        //     setStateListData(states.data);
        //     //Clear District dropdown
        //     // setDistrictListData(null);
        //     //Clear City dropdown
        //     // setCityListData(null);
        // }
        // else {
        //     //Error Handle..
        // }
    };

    const stateChanged = async event => {
        setState(event.target.value);
        if(event.target.value !== ''){
            const selectedItemId = event.target.value;
            const selectedItem = stateList.find((item) => item._id === selectedItemId)
            setLoading(true);
            var districts = await loadGeoLocationData(selectedItem.Id, 3);
            setDistrictListData(districts);
            setCityListData([]);
            setDistrict("");
            setCity("");
            setLoading(false);
        }
        else {
            setDistrict('');
            setDistrictListData([]);
            setCityListData([]);
            setCity("");
        }
        // if (districts.success) {
        //     setDistrictListData(districts.data)
        //     //Clear City dropdown
        //     // setCityListData(null);
        // }
        // else {
        //     //Error Handle..
        // }
    };

    const districtChanged = async (event) => {
        setDistrict(event.target.value);
        if(event.target.value !== ''){
            const selectedItemId = event.target.value;
            const selectedItem = districtList.find((item) => item._id === selectedItemId)
            setLoading(true);
            var cities = await loadGeoLocationData(selectedItem.Id, 4);
            setCityListData(cities);
            setCity("");
            setLoading(false);
        }
        else {
            setCityListData([]);
            setCity("");
        }
        // if (cities.success) {
        //     setCityListData(cities.data);
        // } else {
        //     //Error Handle..
        // }
    };

   const cityChanged = async (event) => {
        setCity(event.target.value);
    }

    const bindFormData = async () => {
        if (location.state.companyid != null) {
            setLoading(true);
            var countrylist = await loadGeoLocationData(0, 1);
            var response = await GetOrganizationById(location.state.companyid);
            
            const selectedCountryId = response.data[0].Country.Id;
            const selectedCountry = countrylist.find((item) => item._id === selectedCountryId);

            var states = await loadGeoLocationData(selectedCountry.Id, 2);
            setStateListData(states);

            const selectedStateId = response.data[0].State.Id;
            const selectedState = states.find((item) => item._id === selectedStateId);

            var districts = await loadGeoLocationData(selectedState.Id, 3);
            setDistrictListData(districts)

            const selectedDistrictId = response.data[0].District.Id;
            const selectedDistrict = districts.find((item) => item._id === selectedDistrictId)

            var cities = await loadGeoLocationData(selectedDistrict.Id, 4);
            setCityListData(cities);

            setCompanyName(response.data[0].Name);
            setBusiness(response.data[0].Business);
            setCompanyBrief(response.data[0].Brief);
            setWebsiteURL(response.data[0].WebsiteURL);
            setLogoURL(response.data[0].Logo);
            // setWebsiteURL(response.data[0].Brief);
            setIsEnabled(response.data[0].IsEnable);
            setAddress1(response.data[0].Address1);
            setCountry(response.data[0].Country.Id);
            setState(response.data[0].State.Id);
            setDistrict(response.data[0].District.Id);
            setCity(response.data[0].City.Id);
            setPincode(response.data[0].Pincode);
            setContactName(response.data[0].ContactName);
            setContacEmail(response.data[0].ContactEmail);
            setContactNumber(response.data[0].ContactNumber);
            setContactDesignation(response.data[0].ContactDesignation);
            setLoading(false);

            const updatedIndustryTypes = response.data[0].IndustryType?.map(item => {
                return {
                    label: item.Name,
                    value: item.Id
                };
            });
            setSelectedIndustryTypes(updatedIndustryTypes);
        }
    }
    const clearState = () => {
        setCompanyName("");
        setBusiness("");
        setSelectedIndustryTypes([]);
        setCompanyBrief("");
        setWebsiteURL("");
        setIsEnabled("");
        setLogoURL("");
        setAddress1("");
        setCountry("");
        setState("");
        setDistrict("");
        setCity("");
        setPincode("");
        setContactName("");
        setContacEmail("");
        setContactNumber("");
        setContactDesignation("");
        
    };
    const clear = () => {
        ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
        .then((result) => {
            if (result.isConfirmed) {
                clearState();
            }
        });
    };
    const promise = async () => {
        const prom = await Promise.all([
            bindFormPreloadData(),
            bindFormData(),
        ])
    }

    const addRefresh = () => {
        navigate('/home', {state: {challengeid: null}});
    }

    const handleCompany = () => {
        navigate('/industrypartner', {state: {challengeid: null}});
    };
    useEffect(() => {
        }, [selectedIndustryTypes]);
    useEffect(() => {
        promise();
        // bindFormPreloadData();
        // bindFormData();
        if (location.state.companyid != null) {
            setIsUpdate(true);
        }
        else {
            setIsUpdate(false);
        }
        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.children[0].classList.add('active');
        }, 300);
    }, [])

    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item  onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item  onClick={() => handleCompany()}> Industry Partner</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Industry Partner Detail</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                {!isUpdate && <h2 className="page-title">Add Industry Partner</h2>}
                                {isUpdate && <h2 className="page-title">Edit Industry Partner</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}
                                        <Form autoComplete="off" noValidate validated={validated} onKeyDown={handleKeyDown} onSubmit={handleSubmit}>
                                            <div className='card-tabsmain'>
                                                <div className='card-details-boxs'>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> <h4>Industry Partner Information</h4></Form.Label>
                                                            </Form.Group>
                                                        </Col><hr/>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Industry Partner Name <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="name" type="text" minLength={3}  id="name" placeholder="Enter Industry Partner Name" required value={companyName} onChange={(e) => setCompanyName(e.target.value)}/>
                                                                    <Form.Control.Feedback type="invalid">Industry Partner Name is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Business Unit/Department<em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control required type="text" value={business} onChange={(e) => setBusiness(e.target.value)} placeholder='Enter Business type'/>
                                                                    <Form.Control.Feedback type="invalid">Business Type is required </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Industry Partner Type <em className="Required">*</em></Form.Label>
                                                                <div className="col multiBranch">
                                                                    <Multiselect
                                                                        style={{
                                                                            multiselectContainer: {
                                                                                color: 'black',
                                                                            },
                                                                            searchBox: {
                                                                                outline:  validated && selectedIndustryTypes.length === 0 ? '1px solid red' : 'none',
                                                                            }
                                                                        }}
                                                                        options={industryTypeList.map(item => ({ label: item.Name, value: item._id }))}
                                                                        selectedValues={selectedIndustryTypes}
                                                                        onSelect={selectedList => { setSelectedIndustryTypes(selectedList) }}
                                                                        onRemove={selectedList => { setSelectedIndustryTypes(selectedList) }}
                                                                        displayValue="label"
                                                                        placeholder="Select Indutry Type"
                                                                    />
                                                                </div>
                                                                <Form.Control.Feedback type="invalid" style={{ display: validated && selectedIndustryTypes.length === 0 ? 'block' : 'none' }}>
                                                                    Industry Partner Type is required
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Website URL</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type="text" minLength={3}  id="websiteURL" value={websiteURL} onChange={(e) => setWebsiteURL(e.target.value)} placeholder="Enter website URL"/>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        {isUpdate && <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Enable<em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Check type="switch" id="ChallengeStatus" checked={isEnabled} onChange={(e) => setIsEnabled(e.target.checked)}/>
                                                                    <div className='col'>
                                                                    </div>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>}
                                                        <Row>
                                                            <Col lg={4}>
                                                                <Form.Group className="mb-3">
                                                                <Form.Label>Logo<span style={{color: '#058798', marginLeft: '0.9rem', fontSize: '0.80em'}}>( Only 5MB files allowed )</span></Form.Label>
                                                                <div className="col">
                                                                    <Form.Control className="mb-2" ref={fileInputRef} accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" type="file" onChange={convertToBase64} />
                                                                    <div className="d-flex justify-content-between align-items-center">{errorMessage && <p className="mb-0" style={{ color: 'red' }}>{errorMessage}</p>}
                                                                    {showRemoveButton && <Button variant='warning' type="button" size="sm" className="ml-auto" onClick={handleRemoveLogo}>Remove</Button>}
                                                                </div></div>
                                                                </Form.Group>
                                                            </Col>
                                                            
                                                            <Col lg={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Card style={{ width: '12rem' }}>
                                                                        <Card.Body>
                                                                            {
                                                                                logoURL &&
                                                                                <Card.Img variant="top" alt='uploaded file' src={logoURL} />
                                                                            }
                                                                        </Card.Body>
                                                                        {
                                                                            !logoURL &&
                                                                            <Card.Footer>
                                                                                <div className='outerbar'>
                                                                                    <div className='innerbar' style={{ width: `${progresspercent}%` }}>{progresspercent}%</div>
                                                                                </div>
                                                                            </Card.Footer>
                                                                        }
                                                                    </Card>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Col lg={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label><h4>Industry Partner Address</h4></Form.Label>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Address</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="address1" type="text" id="Address1" placeholder="Enter Address" value={address1} onChange={(e) => setAddress1(e.target.value)}/>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            {/* <Form.Group className="mb-3">
                                                                <Form.Label>Country <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name ="country" type="text" id="Country" placeholder="Enter Country" value=""  onChange={(e) => setCountry(e.target.value)} required/>
                                                                    <Form.Control.Feedback type="invalid">Country is required </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group> */}
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Country <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={country} onChange={countryChanged}>
                                                                        <option value={''}>Select</option>
                                                                        {countryList.map(item => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">Country is required </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>State <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={state} onChange={stateChanged}>
                                                                        <option value={''}>Select</option>
                                                                        {stateList.map(item => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">State is required </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>District <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={district} onChange={districtChanged}>
                                                                        <option value={''}>Select</option>
                                                                        {districtList.map(item => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">District is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>City </Form.Label>
                                                                <div className='col'>
                                                                <Form.Select as="select" value={city} onChange={cityChanged} ><option value={""}>Select</option>
                                                                    {cityListData.map((item) => (
                                                                        <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                    ))}
                                                                </Form.Select>
                                                                {/* <Form.Control.Feedback type="invalid">City is required</Form.Control.Feedback> */}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Pincode </Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type="numeric" id="Pincode" minLength={6} maxLength={6} placeholder="Enter Pincode" value={pincode} onChange={(e) => setPincode(e.target.value)}/>
                                                                    {/* <Form.Control.Feedback type="invalid">Pincode is required</Form.Control.Feedback> */}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Contact Name <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="name" type="text" minLength={3}  id="name" placeholder="Enter Contact Name" required value={contactName} onChange={(e) => setContactName(e.target.value)}/>
                                                                    <Form.Control.Feedback type="invalid">Contact Name is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Contact Email <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="email" type="email" minLength={3}  id="email" placeholder="Enter Contact email" required value={contactEmail} onChange={(e) => setContacEmail(e.target.value)}/>
                                                                    <Form.Control.Feedback type="invalid">Contact Email is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Contact Number</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type=" numeric" minLength={10} maxLength={10} id="ContactNumber" placeholder="Enter Contact Number" value={contactNumber} onChange={(e) => setValuePhoneNumber(e.target.value)}/>
                                                                    {numberError && <div style={{ color: 'red' }}>{numberError}</div>}
                                                                    {/* <Form.Control.Feedback type="invalid">Contact Number is required</Form.Control.Feedback> */}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Contact Designation <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="name" type="text" minLength={3}  id="name" placeholder="Enter Contact Designation" required value={contactDesignation} onChange={(e) => setContactDesignation(e.target.value)}/>
                                                                    <Form.Control.Feedback type="invalid">Contact Designation is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label><h4>Industry Partner Activities</h4></Form.Label>
                                                            </Form.Group>
                                                        </Col>
                                                        <Row>             
                                                            <Col lg={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label> Activities</Form.Label>
                                                                    <div className='col'>
                                                                        <Form.Control as="textarea" aria-label="With textarea" style={{ height: '280px' }} value={companyBrief} onChange={(e) => setCompanyBrief(e.target.value)} placeholder='Enter Industry Partner activities here...'/>
                                                                        {/* <Form.Control.Feedback type="invalid">Industry Partner Activities is required</Form.Control.Feedback> */}
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={4}>
                                                                <Button variant="danger" type="button" size="sm" aria-label="small button" color='error' onClick={() => clear()}>Clear</Button>
                                                            </Col>
                                                            <Col>
                                                                <div className="d-flex gap justify-content-end">
                                                                    <Button variant="success"  color='success' size='sm' type="submit">Save</Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default CompanyDetail;